import {AbstractItem} from "@app/shared/classes/item";
import {Address} from "@app/shared/classes/address";
import {InvoiceError} from "@app/shared/classes/invoice-error";
import {Vendor} from "@app/shared/classes/vendor";
import {VendorInvoiceChargeCode} from "@app/shared/classes/vendor-invoice-charge-code";
import {PartnerExternalContact} from "@app/shared/classes/partner-external-contact";
import {PartnerPaymentTerms} from "@app/shared/classes/partner-payment-terms";
import {serializeType} from "@app/shared/classes/common";
import {ApprovalStatusType} from "@app/shared/enums/approval-status-type.enum";
import {Type} from "class-transformer";
import {ItemType} from "@app/shared/enums/item-type.enum";
import {FundingType} from "@app/shared/enums/funding-type.enum";

export class VendorInvoiceItem {
  id?: number;
  version?: number;


  invoiceId: number;
  orderItemId: number;

  subtype: ItemType;
  fundingType: FundingType;
  nameOrNumber: string;
  description: string;
  unitCost: number;
  receiptItemId: number;
  abstractItemId: number;
  vendorLaborCategoryId?: number;
  internalNotes: string;
  unitOfMeasureId: number;
  unitOfMeasureDescription: string;

  qtyAlreadyInvoiced: number;
  qtyAlreadyReceived: number;
  qtyReceived: number;
  actualUnitPrice: number;
  extendedPrice: number;
  isTaxable: boolean;
  taxAmount: number;

  // for display
  @Type(serializeType(AbstractItem)) abstractItemDetail: AbstractItem;
  receiptId: number;
  receiptNumber: string;
  purchaseReturnId?: number;
  qtyOrdered: number;
  qtyBackOrdered: number;
  qtyAlreadyReceivedChanged: boolean;
  receivedAll: boolean;

  projectName?: string;                         // vendor labor category associated project
  projectLaborCategoryPositionTitle?: string;   // project labor category associated with the vendor labor category

  @Type(serializeType(VendorInvoiceChargeCode)) invoiceChargeCodes: VendorInvoiceChargeCode[];
}

export class VendorInvoice {
  id?: number;
  version?: number;

  vendorInvoiceNumber: string;
  invoiceNumber: string;
  submittedOn: Date;
  approvedOn: Date;
  currentStatusName?: ApprovalStatusType;
  hasSubmissionError?: boolean;

  cashPurchase: boolean;
  recurring: boolean;
  invoiceDate: string;
  invoiceDueDate: string;
  referenceNumber: string;
  amountDue: number;
  taxRate: number;
  balanceAmount: number;
  earlyPaymentDiscountAmount: number;
  pastDueInterestAmount: number;
  memo: string;
  invoiceErrors: InvoiceError[];

  addressId: number;
  shipToId: number;
  @Type(serializeType(Address)) shipToAddressDetail: Address;
  billToId: number;
  vendorId: number;
  vendorName: string;
  @Type(serializeType(Vendor)) vendorDetail: Vendor;
  @Type(serializeType(PartnerExternalContact)) vendorContactDetail: PartnerExternalContact;
  @Type(serializeType(Address)) vendorAddressDetail: Address;
  purchaseOrderId: number;
  purchaseOrderNumberDetail: string;
  paymentTermsId: number;
  @Type(serializeType(PartnerPaymentTerms)) paymentTermsDetail: PartnerPaymentTerms;
  financeUserId: number;
  financeManagerId: number;
  submittedById: number;
  submittedForId: number;
  contactId: number;
  receiptId: number;
  pdfTemplateId: number;
  accountingPeriodId: number;
  accountingPeriodLabel: string;
  invoicePeriodId: number;
  invoicePeriodLabel: string;

  invoiceId?: number;
  receivedLocationId: number;
  returnId: number;
  terms: string;

  @Type(serializeType(VendorInvoiceItem)) invoiceItems: VendorInvoiceItem[];

  // display properties
  shippingAmount: number;


  constructor(vendorId?: number) {
    if (vendorId) {
      this.vendorId = vendorId;
    }
    this.recurring = false;
    this.invoiceItems = new Array<VendorInvoiceItem>();
  }
}
